













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class CompletedCounter extends Vue {
  @Prop() id!: string;
  @Prop() completed!: number;
  @Prop() total!: number;

  get displayValue() {
    return `${this.completed}/${this.total}`;
  }
}
